import { useState, useContext } from "react";
import { Button, Form, Space, Table } from "antd";

import { ClaimContext } from "../../../context/ClaimContext";

interface StepProps {
  gotoStep: Function;
  current: number;
  coveredLives: any;
}

const CoveredLive: React.FC<StepProps> = ({
  gotoStep,
  current,
  coveredLives,
}) => {
  const { setClaimData, claimData } = useContext(ClaimContext);
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([claimData.id]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      const reducedObject = {};
      
      const selectedRowKeysNumbers = selectedRowKeys.map((key) =>
        parseInt(key as string)
      );

      setSelectedRowKeys(selectedRowKeysNumbers); // Update selectedRowKeys state
      selectedRows.forEach((obj: any) => {
        Object.assign(reducedObject, obj);
      });

      setClaimData((prev: any) => ({ ...prev, ...reducedObject }));
    },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const coveredLiveColumns = [
    {
      title: "ID Number",
      dataIndex: "CoveredIdNumber",
    },
    {
      title: "Covered Type",
      dataIndex: "CoveredType",
    },
    {
      title: "Covered Amount",
      dataIndex: "CoveredAmount",
    },
    {
      title: "Name",
      dataIndex: "CoveredName",
    },
    {
      title: "Surname",
      dataIndex: "CoveredSurname",
    },
    {
      title: "Date Of Birth",
      dataIndex: "CoveredDateOfBirth",
    },
  ];

  const content = (
    <>
      <Space
        size={"large"}
        direction="vertical"
        style={{ width: "100%", textAlign: "center", margin: "0 0 16px 0" }}
      >
        <h2 style={{ color: "#f04f05", padding: "16px 0" }}>
          Select The Deceased Covered Life.
        </h2>
      </Space>
      {coveredLives.length > 0 && (
        <Space
          size={"large"}
          direction="vertical"
          style={{
            width: "100%",
            textAlign: "center",
            margin: "16px 0 24px 0",
          }}
        >
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
            pagination={{
              pageSize: 10,
              position: ["bottomRight"],
              total: 0,
              current: 1,
              hideOnSinglePage: true,
            }}
            columns={coveredLiveColumns}
            rowKey="id"
            dataSource={coveredLives}
          />
        </Space>
      )}
      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            className="claim-continue-btn"
            block
            size="large"
            onClick={() => gotoStep(current + 1)}
          >
            Continue
          </Button>
        </Space>
      </Form.Item>
    </>
  );

  return content;
};

export default CoveredLive;
